<template>
  <v-row class="mb-2">
    <v-col cols="7" class="mx-n4 mt-1">
      <v-card-title v-if="field && field.label">{{ field.label }}</v-card-title>
      <v-card-title v-else>Données HTML personnalisées</v-card-title>
    </v-col>

    <v-col cols="6" class="mt-n9">
      <v-btn x-small @click="prettify"><v-icon>code</v-icon> </v-btn>
    </v-col>

    <v-text-field v-show="false" :rules="[hasValidHtml]" />

    <v-col cols="11" class="mt-n4">
      <div @paste="onPaste">
        <prism-editor v-model="newValue" class="my-editor" :highlight="highlighter" line-numbers />
      </div>
    </v-col>

    <v-col cols="8" class="mb-n3 mx-1 mt-n6 html-error">
      <p>{{ validateHTML }}</p>
    </v-col>
  </v-row>
</template>

<script setup>
import { ref, computed, watch } from 'vue';

import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css'; // import syntax highlighting styles
import { NoUnusedVariablesRule } from 'graphql';

// eslint-disable-next-line no-undef
const emit = defineEmits(['input']);

// eslint-disable-next-line no-undef
const props = defineProps({ field: { type: Object, default: () => { } }, value: { type: [Array, Number, String], default: null } });

const newValue = ref(props.value);
const validateHTML = ref('');

const prettify = () => {
  const el = document.createElement('div');
  el.innerHTML = newValue.value;
  newValue.value = el.outerHTML;

  newValue.value = newValue.value.substring(5, newValue.value.length - 6);
};

const highlighter = code => highlight(code, languages.js, 'html');

const onPaste = () => {
  setTimeout(() => {
    prettify();
  }, 1);
};

const hasValidHtml = computed(() => {
  if (validateHTML.value.length > 0) return "[v=>!!v || 'Required']";
  return true;
});

watch(newValue, value => {
  const el = document.createElement('div');
  el.innerHTML = value;

  try {
    if (el.innerHTML !== value) throw new Error('Error on CodeEditor HTML');

    emit('input', value || null);
    validateHTML.value = '';
  } catch (e) {
    emit('input', value || null);
    validateHTML.value = 'Donnée HTML innatendue';
  }
});
</script>

<style lang="scss" scoped>
/* required class */
.my-editor {
  /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
  background: #020202;
  color: #ccc;

  /* you must provide font-family font-size line-height. Example: */
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  width: 109%;
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
  outline: none;
}

.html-error {
  color: #ef5350;
  font-size: 95%;
}
</style>
